import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/root-reducer';
import { initializeCello } from '../../utils/initialize-third-party-integrations';

interface UseCelloIntegrationWithConfigProps {
  enable?: boolean;
  onError?: (error: any) => void;
}

const useCelloIntegrationWithConfig = ({
  enable = true,
  onError,
}: UseCelloIntegrationWithConfigProps = {}) => {
  const celloAuthToken = useSelector(
    (state: RootState) => state.home.getPostLoadMetaResponse?.celloAuthToken,
  );

  useEffect(() => {
    if (!enable) return;

    try {
      if (celloAuthToken) {
        initializeCello();
      }
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.error('Error initializing Cello:', error);
      }
      onError?.(error);
    }
  }, [enable, celloAuthToken, onError]);

  return null;
};

export default useCelloIntegrationWithConfig; 